import { SET_TODO_LIST } from "../actions/types";

const initialState = {
    todoListData: [],
    todoCount: 0
};
export default function (state = initialState, action) {
    const { type, payload, count } = action;
    switch (type) {
        case SET_TODO_LIST:
            return {
                ...state,
                todoListData: payload,
                todoCount: count,
            };
        default:
            return state;
    }
}
